<template>
    <div class="settingModule">
        <em>Webshop settings</em>
        <transition name="slide-fade" :duration="{ enter: 500, leave: 0 }">
            <div>
                <hr>
                <p class="tagGroupName">Default view</p>
                <div>
                    <label class="container"> Grid
                        <input type="radio" :checked="settingsModule.defaultView == 'grid'" @click="settingsModule.defaultView  = 'grid'" name="view">
                        <span class="checkmark22"></span>
                    </label>
                    <label class="container"> List
                        <input type="radio" :checked="settingsModule.defaultView == 'list'" @click="settingsModule.defaultView  = 'list'" name="view">
                        <span class="checkmark22"></span>
                    </label>
                </div>
                <em>The default view for webshop products.</em>
                <hr>
                <div>
                    <label class="container"> Use global value
                        <input type="radio" :checked="settingsModule.imageView == globalflaptype" @click="settingsModule.imageView  = globalflaptype" name="Image-view">
                        <span class="checkmark22"></span>
                    </label>
                    <label class="container"> Image with mortar
                        <input type="radio" :checked="settingsModule.imageView == 'M'" @click="settingsModule.imageView  = 'M'" name="Image-view">
                        <span class="checkmark22"></span>
                    </label>
                    <label class="container"> Image without mortar
                        <input type="radio" :checked="settingsModule.imageView == 'NM'" @click="settingsModule.imageView  = 'NM'" name="Image-view">
                        <span class="checkmark22"></span>
                    </label>
                </div>
                <em>Image view with mortar or without mortar</em>
                <hr v-if="!this.$root.dynamiccatpage">
                <hr v-if="!this.$root.dynamiccatpage">
                <div v-if="!this.$root.dynamiccatpage">
                    <label class="container"> Show Filter
                        <input type="checkbox" :checked="settingsModule.showFilter  == true" @click="settingsModule.showFilter  = !settingsModule.showFilter" name="filter">
                        <span class="checkbox"></span>
                    </label>
                </div>
                <em v-if="!this.$root.dynamiccatpage">Show sorting filter</em>
                <hr v-if="!this.$root.dynamiccatpage">
                <transition  v-if="!this.$root.dynamiccatpage" name="slide-fade" :duration="{ enter: 500, leave: 0 }">
                    <div v-if="this.settingsModule.showFilter == false && categories.length != 0">
                        <div v-for="(category, index) in categories" :key="index">
                            <p class="tagGroupName">{{category.attribute}}</p>

                          
                            <div v-for="(value, index2) in category.values" :key="index2">
                                <label class="container"> {{value.name}}

                                      <!-- Attributes to include -->
                                    <input type="checkbox" :checked="value.checked" @click="value.checked = !value.checked" name="attr" class="myBox">
                                    <span class="checkbox"></span>                                  
                                </label>
                            </div> 
                        </div>

                        <hr>
                       
                    </div>
                </transition>
                <hr>
                <p class="tagGroupName">Links</p>
                <em>Shown in the toolbar above the product list. Drag or use the arrows to change order.</em>
                <div class="linkEditor" v-if="settingsModule && settingsModule.links">
                    <div
                        class="linkRow"
                        v-for="(link, index) in settingsModule.links"
                        :key="link._key"
                        :class="{ dragging: dragFrom === index, dragOver: dragOver === index && dragFrom !== index }"
                        @dragover.prevent="onDragOver(index, $event)"
                        @drop.prevent="onDrop(index, $event)"
                    >
                        <div class="linkRowToolbar">
                            <span
                                class="dragHandle"
                                draggable="true"
                                title="Drag to reorder"
                                @dragstart="onDragStart(index, $event)"
                                @dragend="onDragEnd"
                            >⋮⋮</span>
                            <button type="button" class="moveLinkBtn" :disabled="index === 0" @click="moveLink(index, index - 1)" title="Move up">▲</button>
                            <button type="button" class="moveLinkBtn" :disabled="index === settingsModule.links.length - 1" @click="moveLink(index, index + 1)" title="Move down">▼</button>
                            <button type="button" class="removeLinkBtn" @click="removeLink(index)" title="Remove link">&times;</button>
                        </div>
                        <input type="text" v-model="link.text" placeholder="Link text">
                        <input type="text" v-model="link.url" placeholder="URL">
                    </div>
                    <button type="button" class="addLinkBtn" @click="addLink">Add link</button>
                </div>
            </div>
        </transition>
        <button :disabled="this.$parent.saving" class="saveRelationsBtn" @click="saveSettings">
            
            <svg v-if="this.$parent.saving" class="fontAwesomeIcon white iconSpin" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z"/></svg>    
            <svg v-else class="fontAwesomeIcon white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V173.3c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32H64zm0 96c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM224 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"/></svg>
            
            <!-- <font-awesome-icon  :icon="['fas', this.$parent.saving ? 'spinner' : 'save']" :spin="this.$parent.saving ? true : false" />  -->
            Save
        </button>
    </div>
</template>

<script>
    import axios from 'axios'
    export default {
        components: {},
        data() {
            return {
                settingsModule: '',
                pickedCat: [],
                showFilter: true,                
                defaultView: '',
                categories: [],
                globalflaptype:'',
                dragFrom: null,
                dragOver: null,
                linkKeySeq: 0,
            }
        },
        mounted() {
            this.getSettings();
        },
        watch: {
            categories: {
                // This will let Vue know to look inside the array
                deep: true,
                // We have to move our method to a handler field
                handler() {
                    this.pickedCat = [];
                    this.categories.forEach(attr => {
                        attr.values.forEach(value => {
                            if (value.checked) {
                                this.pickedCat.push(value.attributeValueId)
                            }
                        })
                    })                    
                }
            }
        },
        methods: {
            getSettings: function() {
                this.globalflaptype = this.$root.globalflaptype;
                var tempArraySettings = [];
                var settingsObj = new Object();
                settingsObj["WCMS_WebPageContent_ID"] = this.$root.contentid;
                tempArraySettings.push(settingsObj)
                axios.get(basedir + '/ajaxRequestServlet?mode=WebContentElement&WCMS_WebPageContent_ID=' + this.$root.contentid).then(response => {
                    this.settingsModule = response.data.AdditionalContentAttributes == "" ? {
                        "defaultView": 'list',
                        "imageView":'M',
                        "showFilter": true,
                        "showCat": [],
                        "hideCat":[],
                        "imagesWithoutMortarID":[],
                        "links": []
                    } : JSON.parse(response.data.AdditionalContentAttributes);
                    if (!this.settingsModule.links) {
                        this.$set(this.settingsModule, 'links', []);
                    }
                    this.ensureLinkKeys();
                    
                    //set data to the widget
                    axios.get(basedir + "/ajaxRequestServlet?mode=AttributeValues&isSearchable=false&isWebAttribute=true&isOnProducts=true").then(response => {
                        response.data.attributes.forEach(element => {
                            element.values.forEach(value => {
                                if (this.settingsModule.showCat.includes(value.attributeValueId)) {                                 
                                    this.$set(value, "checked", true)
                                } else {
                                    this.$set(value, "checked", false)
                                }                               
                            })
                        })
                        this.categories = response.data.attributes
                    })
                });
            },
            saveSettings: function(obj) {
                this.$parent.saving = true;
                var payload = new Object();
                payload["WCMS_WebPageContent_ID"] = this.$root.contentid;
                var links = (this.settingsModule.links || []).filter(function(link) {
                    return (link.text && link.text.trim()) || (link.url && link.url.trim());
                }).map(function(link) {
                    return {
                        text: (link.text || '').trim(),
                        url: (link.url || '').trim()
                    };
                });
                var attributes = {
                    showFilter: this.settingsModule.showFilter,
                    defaultView: this.settingsModule.defaultView,
                    showCat: this.$root.dynamiccatpage ? "dynamic" : this.pickedCat,
                    imageView: this.settingsModule.imageView,
                    imagesWithoutMortarID: this.settingsModule.imagesWithoutMortarID,
                    hideCat: this.settingsModule.hideCat || [],
                    links: links
                };
                payload["AdditionalContentAttributes"] = JSON.stringify(attributes);
                axios.post(basedir + '/ajaxRequestServlet?mode=WebContentElement', JSON.stringify([payload]), {
                    headers: {
                        'Content-Type': 'application/json',
                    }
                }).then(response => {
                    axios.post(basedir + "/adminServlet?action=resetPageCache&WCMS_WebHost_ID=" + this.$root.webhost + "&WCMS_WebPage_ID=" + this.$root.pageid).then(reponse => {
                        this.$emit('saveSettings', {
                            view: this.settingsModule.defaultView,
                            showFilter: this.showFilter,
                            showCat: this.showCat,
                            imageView: this.settingsModule.imageView,
                            imagesWithoutMortarID: this.settingsModule.imagesWithoutMortarID,
                            links: links
                        })
                    })
                })
            },
            addLink: function() {
                if (!this.settingsModule.links) {
                    this.$set(this.settingsModule, 'links', []);
                }
                this.settingsModule.links.push({ text: '', url: '', _key: this.nextLinkKey() });
            },
            removeLink: function(index) {
                this.settingsModule.links.splice(index, 1);
            },
            nextLinkKey: function() {
                this.linkKeySeq += 1;
                return 'link-' + this.linkKeySeq;
            },
            ensureLinkKeys: function() {
                var self = this;
                (this.settingsModule.links || []).forEach(function(link) {
                    if (!link._key) {
                        self.$set(link, '_key', self.nextLinkKey());
                    }
                });
            },
            moveLink: function(from, to) {
                var links = this.settingsModule.links;
                if (from == null || to == null || from === to) {
                    return;
                }
                if (to < 0 || to >= links.length) {
                    return;
                }
                var item = links.splice(from, 1)[0];
                links.splice(to, 0, item);
            },
            onDragStart: function(index, event) {
                this.dragFrom = index;
                event.dataTransfer.effectAllowed = 'move';
                event.dataTransfer.setData('text/plain', String(index));
            },
            onDragOver: function(index, event) {
                event.dataTransfer.dropEffect = 'move';
                this.dragOver = index;
            },
            onDrop: function(index) {
                this.moveLink(this.dragFrom, index);
                this.dragFrom = null;
                this.dragOver = null;
            },
            onDragEnd: function() {
                this.dragFrom = null;
                this.dragOver = null;
            }
        }
    }
</script>

<style lang="scss" scoped>
    input[type=number]::-webkit-inner-spin-button,
    input[type=number]::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    svg[data-prefix="fas"] {
        color: #75c791;
        min-width: 27px;
        margin-left: -5px;
        transition: all 0.3s ease-in-out;
    }
    button svg[data-prefix="fas"] {
        color: white !important;
        margin-left: 0;
        width: auto;
        min-width: unset;
    }
    svg.deactive {
        color: gray;
    }
    .tagGroupName {
        font-weight: bold;
        color: #74c791;
        margin-bottom: 0;
        margin-top: 10px;
    }
    .settingModule {
        position: absolute;
        right: 0;
        margin-top: 37px;
        z-index: 1000;
        margin-right: 15px;
        background: #f9f9f9;
        width: auto;
        text-align: left;
        float: right;
        min-width: 255px;
        max-width: 350px;
        padding: 13px;
        transition: height 0.5s linear;
        border: 1px solid #00457042;
        border-radius: 5px;
        box-shadow: 0 0 8px  #d2d2d2;
        em {
            color: #9a9a9a;
            font-size: 0.7em;
            margin-bottom: 10px;
            display: block;
        }
        .linkEditor {
            .linkRow {
                display: flex;
                flex-wrap: wrap;
                gap: 6px;
                align-items: center;
                margin-bottom: 8px;
                padding: 6px;
                border: 1px solid transparent;
                border-radius: 4px;
                background: #fff;
                &.dragging {
                    opacity: 0.45;
                }
                &.dragOver {
                    border-color: #75c791;
                    background: #74c7911a;
                }
            }
            .linkRowToolbar {
                display: flex;
                align-items: center;
                gap: 2px;
                width: 100%;
            }
            .dragHandle {
                cursor: grab;
                color: #9a9a9a;
                letter-spacing: -2px;
                font-size: 14px;
                line-height: 1;
                padding: 2px 6px 2px 0;
                user-select: none;
                &:active {
                    cursor: grabbing;
                }
            }
            .moveLinkBtn {
                background: none;
                border: 1px solid #cecece;
                border-radius: 3px;
                color: #004570;
                cursor: pointer;
                font-size: 9px;
                line-height: 1;
                padding: 3px 5px;
                &:disabled {
                    color: #cecece;
                    cursor: not-allowed;
                }
                &:not(:disabled):hover {
                    background: #74c7911a;
                    border-color: #75c791;
                }
            }
            input[type="text"] {
                float: none;
                flex: 1 1 100%;
                width: 100%;
                margin: 0;
                padding: 6px 8px;
                box-sizing: border-box;
            }
            .removeLinkBtn {
                background: none;
                border: none;
                color: #c0392b;
                font-size: 18px;
                cursor: pointer;
                padding: 0 4px;
                line-height: 1;
                margin-left: auto;
            }
            .addLinkBtn {
                background: #004570;
                color: #fff;
                border: none;
                border-radius: 4px;
                padding: 6px 10px;
                cursor: pointer;
                font-weight: 600;
                font-size: 12px;
            }
        }
    }
    label[for="resultNo"] {
        padding-left: 4px;
    }
    .toggle {
        margin-bottom: 5px;
        label {
            max-width: 70%;
        }
    }
    label {
        display: inline-block;
        padding: 6px;
        margin-top: -1px;
    }
    input[type="text"],
    input[type="number"],
    input[type="email"] {
        float: right;
        border: 1px solid #cecece;
        &:focus {
            border: 1px solid #75c791;
        }
    }
    .vue-js-switch {
        float: right;
    }
    .saveRelationsBtn {
        display: flex;
        justify-content: center;
        gap: 5px;

        width: 100%;
        cursor: pointer;
        margin-top: 20px;
        background: #75c791;
        border: 0;
        padding: 10px;
        color: white;
        font-weight: bold;
        text-transform: uppercase;

        &:disabled {
            &:hover {
                background: #bfcbd9;
            }
            background:#bfcbd9;
            cursor:not-allowed;
        }
        &:hover {
            background: #98e2b0;
        }
    }
    #resultNo {
        border-radius: 6px;
        padding: 6px;
        color: #75c791;
        font-weight: bold;
        text-align: center;
        width: 40px;
    }
    /* Customize the label (the container) */
    .container {
        display: block;
        position: relative;
        text-align: left;
        font-size: 1em;
        font-size: 1em;
        padding-left: 5px;
        margin: 0;
        cursor: pointer;
        width: 100%;
        margin-right: 32px;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        &:hover {
            background: #74c7911a;
            border-radius: 7px;
        }
    }
    /* Hide the browser's default radio button */
    .container input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }
    /* Create a custom radio button */
    .checkmark22 {
        position: absolute;
        top: 5px;
        right: 38px;
        height: 20px;
        width: 20px;
        background-color: #eee;
        border-radius: 50%;
        border: 2px solid #a4b0bd;
    }
    .checkbox {
        position: absolute;
        top: 5px;
        right: 38px;
        height: 20px;
        width: 20px;
        background-color: #eee;
        border-radius: 17%;
        border: 2px solid #a4b0bd;
    }

    .checkboxBlacklist{
        position: absolute;
        top: 5px;
        right: 8px;
        height: 20px;
        width: 20px;
        background-color: #eee;
        border-radius: 17%;
        border: 2px solid #a4b0bd;
    }
    /* On mouse-over, add a grey background color */
    .container:hover input~.checkmark22,
    .container:hover input~.checkbox {
        background-color: #ccc;
    }
    /* When the radio button is checked, add a blue background */
    .container input:checked~.checkmark22,
    .container input:checked~.checkbox {
        background-color: #75c791;
        border: 2px solid #75c791;
    }

    .container input:checked~.checkboxBlacklist {
        background-color: #fb665b;
        border: 2px solid #fb665b;
    }


    /* Create the indicator (the dot/circle - hidden when not checked) */
    .checkmark22:after,
    .checkbox:after {
        content: "";
        position: absolute;
        display: none;
    }
    /* Show the indicator (dot/circle) when checked */
    .container input:checked~.checkmark22:after,
    .container input:checked~.checkbox:after {
        display: block;
    }
    /* Style the indicator (dot/circle) */
    .container .checkmark22:after,
    .container .checkbox:after {
        top: 6px;
        left: 6px;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: white;
    }
    /* Enter and leave animations can use different */
    /* durations and timing functions.              */
    .slide-fade-enter-active {
        transition: all .3s ease;
    }
    .slide-fade-leave-active {
        transition: all 0s ease;
    }
    .slide-fade-enter,
    .slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */
    {
        transform: translateY(10px);
        opacity: 0;
    }
</style>